export default __webpack_public_path__ + "media/images/onglet-rightclick1-6814ea0ab05ce14d96867cfaedd38d10.png";